import "chosen-js/chosen.css";
import "chosen-js/chosen.jquery.js";
import "./jPages.min";
import "jquery-bbq";

function processClassificationTemplate(job, closed_date) {
  var content = '<ul class="classifications">';

  $.each(job.classifications, function () {
    let values = this.values.map((v) => v.class_val).join(', ');
    if (values !== "") {
      content = content + '<li class="jobclass"><span class="jobclass_type">' + this.name + ':</span> <span class="jobvalue">' + values + '</span></span>';
      values = "";
    }
  });
  /*Add reference number and closing date*/
  content = content + '<li class="jobclass"><span class="jobclass_type">Ref No: </span> <span class="jobvalue">' + job.refno + '</span></span>';

  if (closed_date !== "") {
    content = content + '<li class="jobclass"><span class="jobclass_type">Closing Date: </span> <span class="jobvalue">' + closed_date + '</span></span>';
  }

  content += "</ul>";
  return content;
}


/*	Process the The buttons template    
---------------------------------------------------------------------------------------------------------------------
  ---------------------------------------------------------------------------------------------------------------------*/
function processButtonsTemplate(job) {
  return '<div class="jobpost_nav"><p>' +
    '<a href="' + job.weblink + '" class="job_list_read_more" title="Read more (' + job.title + ')">Read more</a>' +
    '<a href="/wd/plsql/wd_portal.send_a_friend?p_web_site_id=6235&amp;p_web_page_id=' + job.id + '" class="send_a_friend" title="Share (' + job.title + ')">Share</a>' +
    '</p></div>';
}



/*	Process the The job template    
---------------------------------------------------------------------------------------------------------------------
---------------------------------------------------------------------------------------------------------------------*/

function processBodyTemplate(job, content, buttons) {
  return '<div class="jobCard">  <div class="card-body">  <h2 class="card-title"> <a href="' + job.weblink + '"> ' + job.title + '</a> </h2>' + content + '<div class="job-summ-div">' + (job.summary.length > 137 ? job.summary.substring(0, 134) + '...' : job.summary) + '<a href="' + job.weblink + '" class="readMore btn btn-default btn-primary">Details</a>	 </div>  </div>  </div>';
}

export class Filters {
  start = 0;
  end = 10;
  page_size = 10;
  current_page = 1;
  searchFormName;
  xhr;
  cookieSaveEnabled = false;
  cookieName = 'ajax_search_cookie';
  enableLoadWithNoState = false;
  reloadEnabled = false;
  formURL;
  contentArea;
  form;
  visibleClassifications = [];
  JPages = false;
  navDiv = "";
  JPagesContainer = "";
  JPagesCount = "";
  chosen = false;
  bbq = false;
  searchButtonClass = ".search_ajaxss .submit";
  no_matching_jobs_text = "<div><p class='alert alert-info'>Unfortunately we currently have no positions that match your search criteria.</p></div>";
  loading_image_html = '<img class="loadingImage" src="/incl/images/loading.gif" alt="Loading Image"/>';

  constructor(config) {
    this.no_matching_jobs_text = hs_texts.srch_no_hits_text || this.no_matching_jobs_text

    /*Combine the config with default values*/
    for (let attrname in config) {
      this[attrname] = config[attrname];
    }
    /*set up for external or internal*/
    this.checkInternalExternal();

    /*Upgrade the select boxes to use multiple selects*/
    this.upgradeSelectBoxes();

    /*upgrade the text field*/
    this.textSearchField = this.form.find("#p_text");
    this.textSearchField.attr('placeholder', 'Enter Keywords');

    /*Enable the typing timer */
    if (this.enableTypetimer) {
      this.initTypingTimer();
    }

    /*enable the search field*/
    this.createSearchButton();

    if (this.chosen) {
      this.initChosen('.search_ajaxss select', true);
    }

    if (this.bbq) {
      this.initBBQ();
    }

    if (this.checkbox) {
      this.initCheckboxes('.search_ajaxss input[type="checkbox"]');
    }

    this.reloadEnabled = true;

  }

  createSearchButton() {
    var _this = this;
    $(_this.searchButtonClass).click(function (e) {
      e.preventDefault();
      _this.reload();
    });
  }

  checkInternalExternal() {
    if (this.form.find("#publishTo").val() === 'WWW') {
      this.external = true;
    } else {
      this.external = false;
    }
  }

  initChosen(className, refreshOnSelect) {
    $(className).chosen({
      display_disabled_options: false
    });

    if (refreshOnSelect) {
      $(className).bind('change', (event, ui) => {
        if (this.reloadEnabled) {
          this.reload();
        }
      });
    }
  }

  initCheckboxes(className) {
    $(className).on('change', () => {
      if (this.reloadEnabled) {
        this.reload();
      }
    });
  }

  upgradeSelectBoxes() {
    this.form.find("select").each(function () {
      var select = $(this);
      select.attr("multiple", "multiple");
      var option = select.find("option").first();
      select.attr('data-placeholder', option.text());
      option.remove();
    });
  }


  initTypingTimer() {
    /*setup before functions*/
    var typingTimer; /*timer identifier*/
    var doneTypingInterval = 100; /*time in ms,*/

    /*prevent the ability for the user to press enter on the form*/
    this.textSearchField.keypress((event) => {
      if (event.keyCode == 10 || event.keyCode == 13) {
        event.preventDefault();
        this.reload();
      }
    });

    /*on keyup, start the countdown*/
    this.textSearchField.keyup(() => {
      clearTimeout(typingTimer);

      if (this.textSearchField.val) {
        typingTimer = setTimeout(() => $(this.searchButtonClass).click(), doneTypingInterval);
      }
    });

  }


  enableJPages(nav, container, count) {
    this.JPages = true;
    this.navDiv = nav;
    this.JPagesContainer = container;
    this.JPagesCount = count;
  }

  initJPages() {

    $(this.navDiv).jPages({
      containerID: this.JPagesContainer,
      first: "«",
      previous: "‹",
      next: "›",
      last: "»",
      perPage: this.JPagesCount,
      minHeight: false,
      callback: function (pages, items) {
        if (this.scrollToTop) {
          $('html').animate({
            scrollTop: 0
          }, 1); /*IE, FF*/
          $('body').animate({
            scrollTop: 0
          }, 1); /*chrome,*/
        }
      }
    });
  }

  initBBQ() {
    var form = $(this.form);
    /*get the state from the url*/
    var cur_state = $.bbq.getState("filter");
    if ((typeof cur_state === 'undefined') && this.cookieSaveEnabled) {
      if (!this.enableLoadWithNoState) {
        this.reloadEnabled = false;
      }
      cur_state = getCookie(this.cookieName);

    }
    var form_data = $.deparam.querystring(cur_state);

    $.each(form_data, function (k, v) {
      if (typeof v === 'string') {
        v = [v];
      }

      $.each(v, function (x, val) {
        if (k === 'p_search') {
          $('#p_text').val(v);

        } else if (k.indexOf("p_category_code_arr") !== -1) {
          var select = $('select[name=p_category_code_arr]', form).val(val);
          select.data();
        }
      });
    });

    $(".search_ajaxss select").trigger("change");
    $(".search_ajaxss select ").trigger("chosen:updated.chosen");

    if (!this.enableLoadWithNoState) {
      this.reloadEnabled = false;
    }

    if ($('.search_ajaxss input[type="radio"]input[checked="checked"]').length === 0) {
      $(".search_ajaxss select").trigger("chosen:updated.chosen");
    }

    if (!this.enableLoadWithNoState) {
      this.reloadEnabled = true;
    }
  }

  updateCookieState() {
    setCookie(this.cookieName, $(this.form).serialize(), 10);
  }

  updateState() {
    if (!this.bbq) {
      return;
    }

    if (this.cookieSaveEnabled) {

      this.updateCookieState();
      $.bbq.pushState({
        filter: $(this.form).serialize()
      });
    } else {

      $.bbq.pushState({
        filter: $(this.form).serialize()
      });

    }

  }

  gotoPage(page) {
    this.start = (page_size * page) - 10;
    this.end = (page_size * page);
  }

  resetPage(page) {
    this.start = 0;
    this.end = page_size;
  }

  readSearchHash() {
    var searchHash;
    if (window.location.hash) {
      try {
        searchHash = location.hash.match(new RegExp('p_search' + '%20([^&]*)'))[1];
      } catch (e) { }

    }
  }

  submit() {
    this.updateState();
    document.location.href = "/current_vacancies.html#" + $.param.fragment();
  }

  createJobTile(job) {
    var closingDate = "";
    var dateStr = "";
    var closedDate;
    /*Show external or internal job dates*/
    if (window.external === true) {
      closingDate = job.publication.internet.closing_date;
    } else {
      closingDate = job.publication.intranet.closing_date;
    }

    dateStr = closingDate;
    closedDate = '';

    try {
      closedDate = formatDate($.datepicker.parseDate("yy-mm-dd", dateStr.split(' ')[0]));
    } catch (e) {
      closedDate = '';
    }

    return processBodyTemplate(job, processClassificationTemplate(job, closedDate), processButtonsTemplate(job));
  }

  /* Ajax request to display XML Job feed */
  /*--------------RELOAD------------------*/
  reload(reset) {
    //Call the ajax method to process the xml file.
    if ($('.jobs_list').length > 0) {
      var _this = this;
      if (this.xhr) {
        this.xhr.abort();
      }
      // if (reset === true) {
      // 	this.resetPage();
      // }

      // process form data 

      var processed_form_data = _this.form.serializeArray();
      $.each(processed_form_data, function (k, v) {

        if (v.name === "p_search") {
          if (v.value !== '') {
            v.value.replace(" ", "%");
            v.value = "%" + v.value + "%";
          }
        }
      });

      processed_form_data = $.param(processed_form_data);

      this.xhr = $.ajax({
        //Set HTTP request type to "GET" and also provide the name of XML file in url.
        type: "GET",
        url: _this.formURL,
        dataType: 'json',
        //Set the datatype to "xml".
        data: processed_form_data + '&p_summary=Y',
        //Display Loading image
        beforeSend() {
          _this.contentArea.html(_this.loading_image_html);
        },

        //success callback is called then loop through the xml content to find variables.
        success(xml) {
          // Declare varaibles

          var count = 0;
          var content = "";

          $(xml.jobs).each((index, job) => {
            count++;
            content += _this.createJobTile(job);
          });

          if (count === 0) {
            content = '<div>' + _this.no_matching_jobs_text + '</div>';
          }

          /*add content string to search content window*/
          _this.contentArea.html(content);

          if (_this.JPages) {
            _this.initJPages();
          }
          _this.updateState();

        },

        /*Define error callback to handle the error*/
        error(e, b, c) {
          _this.contentArea.html("Sorry something went wrong.");
          console.log(e);
          console.log(b);
          console.log(c);
        }
      });
    }
  }
}
